import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Label,
  Input,
  Button,
  Table
} from "reactstrap";

const MedicalInsurers = () => {
  const [filters, setFilters] = useState({
    insurerName: "",
    accountNo: ""
  });

  const [data] = useState([
    { name: "ABSA LIFE", accountNo: "MED_INS_001" },
    { name: "ACUMEN HEALTH", accountNo: "MED_INS_076" },
  ]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters({
      ...filters,
      [name]: value
    });
  };

  const handleClear = () => {
    setFilters({ insurerName: "", accountNo: "" });
  };

  const filteredData = data.filter(
    (item) =>
      item.name.toLowerCase().includes(filters.insurerName.toLowerCase()) &&
      item.accountNo.toLowerCase().includes(filters.accountNo.toLowerCase())
  );

  return (
    <Container fluid>
      <Card>
        <CardBody>
          <h5>Medical Insurers</h5>
        <Row className="mb-3 mt-3">

  <Col md={6}>
    <FormGroup>
      <Label>Insurer name</Label>
      <Input
        type="text"
        name="insurerName"
        value={filters.insurerName}
        onChange={handleChange}
      />
    </FormGroup>
  </Col>

  {/* Force a break */}
  <div className="w-100"></div>

  <Col md={6}>
    <FormGroup>
      <Label>Account no.</Label>
      <Input
        type="text"
        name="accountNo"
        value={filters.accountNo}
        onChange={handleChange}
      />
    </FormGroup>
  </Col>

  <div className="w-100"></div>


  <Col
    md={12}
   className="d-flex align-items-end justify-content-end"
  >
    <Button
      color="secondary"
      className="me-2"
      onClick={handleClear}
    >
      Clear
    </Button>
    <Button color="warning">Search</Button>
  </Col>
</Row>


          <Table borderless>
            <thead>
              <tr>
                <th>Medical Insurer Name</th>
                <th>Account no.</th>
              </tr>
            </thead>
            <tbody>
              {filteredData.map((insurer, index) => (
                <tr key={index}>
                  <td>{insurer.name}</td>
                  <td>{insurer.accountNo}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </CardBody>
      </Card>
    </Container>
  );
};

export default MedicalInsurers;
